import { useEffect, useState } from "react";
import Modal from "../../components/modal/modal.component";
import { UtilsService } from "../../services/utils";
import { SystemUserService } from "../../services/system-user";
import { AlertService } from "../../services/alert.service";

export default function ListUsersModal({ show, account, setShow }: any) {
  const [list, setList] = useState<any[]>([]);

  const getList = async () => {
    const data = await SystemUserService.list(account);
    setList(data);
  };

  const handleStatus = async (_id: string, status: boolean) => {
    await AlertService.warning(
      `${status ? 'Desactivar': 'Activar'} usuario`, 
      `¿Estás seguro de querer ${status ? 'desactivar': 'activar'} este usuario?`, 
      async () => {
        await SystemUserService.handleStatus(_id, !status);
        await getList();

        AlertService.toastSuccess(`El usuario se ${status ? 'desactivó': 'activó'} exitosamente`);
      }
    )
  };

  useEffect(() => {
    if (show) {
      getList();
    } else {
      setList([]);
    }
  }, [show]);

  return (
    <Modal show={show} className="modal-xl">
      <div className="modal-header">
        <h3 className="modal-title">Usuarios de la cuenta</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="table-responsive" id="">
          <table
            className="table align-middle table-row-dashed fs-6 gy-5 dataTable"
            id="kt_table_users"
          >
            <thead>
              <tr
                className="text-start text-muted fw-bold fs-7 text-uppercase gs-0"
                role="row"
              >
                <th
                  className="min-w-125px "
                  colSpan={1}
                  rowSpan={1}
                  tabIndex={0}
                >
                  <span className="">ID</span>
                  <span className="dt-column-order" />
                </th>
                <th
                  aria-label="Role: Activate to sort"
                  className="min-w-125px "
                  colSpan={1}
                  rowSpan={1}
                  tabIndex={0}
                >
                  <span className="">Nombre</span>
                  <span className="dt-column-order" />
                </th>
                <th
                  aria-label="Last login: Activate to sort"
                  className="min-w-125px "
                  colSpan={1}
                  rowSpan={1}
                  tabIndex={0}
                >
                  <span className="">Estatus</span>
                  <span className="dt-column-order" />
                </th>
                <th
                  aria-label="Last login: Activate to sort"
                  className="min-w-125px "
                  colSpan={1}
                  rowSpan={1}
                  tabIndex={0}
                >
                  <span className="">Rol</span>
                  <span className="dt-column-order" />
                </th>
                <th
                  aria-label="Joined Date: Activate to sort"
                  className="min-w-125px "
                  colSpan={1}
                  rowSpan={1}
                  tabIndex={0}
                >
                  <span className="">Fecha de creación</span>
                  <span className="dt-column-order" />
                </th>
                <th
                    aria-label="Actions"
                    className="text-end min-w-100px dt-orderable-none"
                    colSpan={1}
                    rowSpan={1}
                  >
                    <span className="">Acciones</span>
                    <span className="dt-column-order" />
                  </th>
              </tr>
            </thead>
            <tbody className="text-gray-600 fw-semibold">
              {list.map((row) => (
                <tr key={row._id}>
                  <td>{row._id}</td>
                  <td>
                    <div className="d-flex flex-column">
                      <p className="text-gray-800 m-0">{row.name}</p>
                      <span>{row.email}</span>
                    </div>
                  </td>
                  <td>
                    {row.status ? (
                      <div className="badge badge-success fw-bold">Activo</div>
                    ) : (
                      <div className="badge badge-danger fw-bold">Inactivo</div>
                    )}
                  </td>
                  <td>{UtilsService.formatRole(row.role)}</td>
                  <td>{UtilsService.dateFormat(row.created_at)}</td>
                  <td className="text-end">
                    <button
                      className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm"
                      onClick={() => {
                          handleStatus(row._id, row.status)
                        }
                      }
                    >
                      { row.status ? 'Desactivar' : 'Activar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot />
          </table>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-primary" onClick={setShow}>
          Cerrar
        </button>
      </div>
    </Modal>
  );
}
